/* eslint-disable no-underscore-dangle */
import React, { Component } from "react";
import { createTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
//import MomentUtils from "@date-io/moment";
//import { MuiPickersUtilsProvider } from "material-ui-pickers";
import { Redirect, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import "assets/vendors/style";
import orangeTheme from "./themes/orangeTheme";
import darkTheme from "./themes/darkTheme";
import AppLocale from "../lngProvider";
import "react-perfect-scrollbar/dist/css/styles.css";

import MainApp from "app/index";
import SignIn from "./SignIn";
import { setInitUrl } from "../actions/Auth";
import { setNetworkErrorStatus } from "../actions/Common";
import RTL from "util/RTL";
import asyncComponent from "util/asyncComponent";
import { setDarkTheme } from "../actions/Setting";
import { setPublicIP } from "../util/localStorageService";

const publicIp = require("react-public-ip");
publicIp.v4().then(ip => {
  setPublicIP(ip);
});

const RestrictedRoute = ({ component: Component, token, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      token ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/signin", state: { from: props.location } }}
        />
      )
    }
  />
);

class App extends Component {
  componentDidMount() {
    window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true;
    if (this.props.initURL === "") {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
  }

  getColorTheme() {
    return createTheme(orangeTheme);
  }

  render() {
    const {
      match,
      location,
      isDarkTheme,
      locale,
      token,
      initURL,
      isDirectionRTL
    } = this.props;

    let applyTheme = this.getColorTheme();

    if (isDarkTheme) {
      document.body.classList.add("dark-theme");
      applyTheme = createTheme(darkTheme);
    } else {
      applyTheme = this.getColorTheme();
    }

    if (location.pathname === "/") {
      if (token === null) {
        return <Redirect to={"/signin"} />;
      } else if (initURL === "" || initURL === "/" || initURL === "/signin") {
        return <Redirect to={"/app/tradingAccounts/listing"} />;
      } else {
        return <Redirect to={initURL} />;
      }
    }
    if (isDirectionRTL) {
      applyTheme.direction = "rtl";
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
      applyTheme.direction = "ltr";
    }

    const currentAppLocale = AppLocale[locale.locale];
    return (
      <ThemeProvider theme={applyTheme}>
        {/* <MuiPickersUtilsProvider utils={MomentUtils}> */}
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <RTL>
              <div className="app-main">
                <Switch>
                  <RestrictedRoute
                    path={`${match.url}app`}
                    token={token}
                    component={MainApp}
                  />
                  <Route path="/signin" component={SignIn} />
                  {/* <Route path='/signup' component={SignUp}/> */}
                  <Route
                    component={asyncComponent(() =>
                      import("components/Error404")
                    )}
                  />
                </Switch>
              </div>
            </RTL>
          </IntlProvider>
        {/* </MuiPickersUtilsProvider> */}
      </ThemeProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth, commonData }) => {
  const {
    themeColor,
    sideNavColor,
    darkTheme,
    locale,
    isDirectionRTL
  } = settings;
  const { isNetworkError } = commonData;
  const { authUser, token, initURL } = auth;
  return {
    themeColor,
    token,
    sideNavColor,
    isDarkTheme: darkTheme,
    locale,
    isDirectionRTL,
    authUser,
    initURL,
    isNetworkError
  };
};

export default connect(
  mapStateToProps,
  { setInitUrl, setDarkTheme, setNetworkErrorStatus }
)(App);
